import { cloneDeep } from "lodash"

const getTime = (date: string | null | undefined) => (date ? new Date(date).getTime() : Infinity)

export const sortProjectsByPlan = <T extends SortableProject>(projects: T[]): T[] => {
  const cloned = cloneDeep(projects)
  return cloned.sort((a, b) => {
    const endTimeA = getTime(a.plannedEndDate)
    const endTimeB = getTime(b.plannedEndDate)

    if (endTimeA !== endTimeB) return endTimeA - endTimeB

    const startTimeA = getTime(a.plannedStartDate)
    const startTimeB = getTime(b.plannedStartDate)

    if (startTimeA !== startTimeB) return startTimeA - startTimeB

    const createdAtA = getTime(a.createdAt)
    const createdAtB = getTime(b.createdAt)

    return createdAtA - createdAtB
  })
}

export const sortProjectsByCreatedAt = <T extends SortableProject>(projects: T[]): T[] => {
  const cloned = cloneDeep(projects)
  return cloned.sort((a, b) => {
    const createdAtA = getTime(a.createdAt)
    const createdAtB = getTime(b.createdAt)

    return createdAtA - createdAtB
  })
}

type SortableProject = {
  createdAt?: string
  plannedStartDate?: string | null
  plannedEndDate?: string | null
}
